<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h4 class="font-weight-bold text-primary">Report Rate</h4>
      <b-row class="mt-5">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" align="right" class="my-1">
          <b-input-group>
            <b-input-group-text class="bg-white border-right-0" slot="prepend">
              <img src="@/assets/filter.svg" alt />
            </b-input-group-text>
            <b-dropdown
              text="Filter Data"
              variant="light"
              toggle-class="bg-white border-secondary text-primary border-left-0 pl-0"
              slot="append"
            >
              <div class="p-3">
                Rate Type
                <br />
                <br />
                <b-form-checkbox-group v-model="rate_type" :options="options" name="flavour-1a"></b-form-checkbox-group>
                <br />Period
                <br />
                <br />
                <b-row>
                  <b-col>
                    <b-row class="m-0">
                      <b-col
                        class="pr-0 form-control form-control-sm img-calender-select border-right-0"
                        md="4"
                      >
                        <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class="mt-n1" />
                      </b-col>
                      <b-col md="7" class="px-0">
                        <datepicker
                          input-class="form-control form-control-sm text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                          placeholder="Select Date"
                          v-model="period_start"
                          :format="customFormatter"
                          :disabledDates="disabledDates"
                        ></datepicker>
                      </b-col>
                      <b-col align="left" md="1" class="px-0">
                        <b-col
                          align="left"
                          class="px-4 form-control form-control-sm del-calender-select border-left-0"
                          md="2"
                        >
                          <b-row align="left">
                            <b-col>
                              <b-button
                                class="m-0 p-0 mt-n1 bg-transparent border-0"
                                @click="resetStardate"
                                variant="outline-light"
                              >
                                <i class="text-danger fas fa-times"></i>
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="1"></b-col>
                  <b-col>
                    <b-row class="m-0">
                      <b-col
                        class="pr-0 form-control form-control-sm img-calender-select border-right-0"
                        md="4"
                      >
                        <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class="mt-n1" />
                      </b-col>
                      <b-col md="7" class="px-0">
                        <datepicker
                          input-class="form-control form-control-sm text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                          placeholder="Select Date"
                          v-model="period_end"
                          :format="customFormatter"
                          :disabledDates="disabledDates"
                        ></datepicker>
                      </b-col>
                      <b-col align="left" md="1" class="px-0">
                        <b-col
                          align="left"
                          class="px-4 form-control form-control-sm del-calender-select border-left-0"
                          md="2"
                        >
                          <b-row align="left">
                            <b-col>
                              <b-button
                                class="m-0 p-0 mt-n1 bg-transparent border-0"
                                @click="resetEnddate"
                                variant="outline-light"
                              >
                                <i class="text-danger fas fa-times"></i>
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="1"></b-col>
                </b-row>
                <br />
                <br />
                <b-button variant="outline-secondary" @click="reset()" class="mr-3">Reset</b-button>
                <b-button variant="primary" @click="apply()">Apply</b-button>
              </div>
              <b-dropdown-item class="pointer-off" style="width:450px;"></b-dropdown-item>
            </b-dropdown>
          </b-input-group>
        </b-col>
        <b-col md="3" class="my-1" align="right">
          <!-- <b-dropdown
            :disabled="selected.length === 0"
            id="dropdown-1"
            text="Action"
            variant="primary"
            class="m-md-2"
          >
            <b-dropdown-item @click="submitStatus('publish')" href="#">Publish</b-dropdown-item>
            <b-dropdown-item @click="submitStatus('archive')" href="#">Archive</b-dropdown-item>
          </b-dropdown>-->
          <router-link :to="{name: 'createReason'}">
            <b-button variant="primary">
              <img src="@/assets/ic-status.svg" class="mr-2" alt />Export CSV
            </b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        show-empty
        hover
        ref="selectableTable"
        selectable
        :select-mode="selectMode"
        @row-selected="onRowSelected"
        responsive="sm"
        :items="getInfo"
        :fields="key"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
        filter-debounce="500"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:head(selected)="data">
          <span class="text-info">
            <b-form-checkbox
              v-model="allSelected"
              :indeterminate="indeterminate"
              aria-describedby="items"
              aria-controls="items"
              @change="toggleAll"
              :value="data"
            ></b-form-checkbox>
          </span>
        </template>
        <template v-slot:cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
        <template v-slot:cell(created_at)="row">
          <div>{{row.value.substring(0,10)}}</div>
        </template>
        <template v-slot:cell(image)="row">
          <b-img :src="row.value" width="70px" rounded alt="Image"></b-img>
        </template>
        <template v-slot:cell(status)="row">
          <p class="text-success" v-if="row.value == 'publish'">Publish</p>
          <p class="text-warning" v-else-if="row.value == 'archive'">Archive</p>
        </template>
        <template v-slot:cell(title.id)="row">
          <div v-html="row.value.substring(0,20)"></div>
        </template>
        <template v-slot:cell(action)="{ value, item }">
          <router-link
            v-b-tooltip.hover
            title="Edit"
            :to="{name: 'editReason', params: {id: item.id}}"
            class="text-dark"
          >
            <img src="@/assets/ic-edit.svg" class="mr-2" alt />
          </router-link>
          <b-link v-b-tooltip.hover title="Delete" class="text-dark" @click="del(item.id)">
            <img src="@/assets/rectangle.svg" alt />
          </b-link>
        </template>
      </b-table>

      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{rows}}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      loading: false,
      errored: false,
      items: [],
      vuex: [],
      selected: [],
      key: [
        {
          key: 'selected',
          class: 'text-center',
        },
        {
          key: 'created_at',
          label: 'Created',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'member_code',
          label: 'User ID',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'member_full_name',
          label: 'Full Name',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'shipment_code',
          label: 'Shipment Code',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'rate.type',
          label: 'Rate Type',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'rate.title.id',
          label: 'Rating',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'reason.reason_id',
          label: 'Reason',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'hero_name',
          label: 'Hero Name',
          sortable: true,
          class: 'text-center',
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: true,
      sortDirection: 'asc',
      filter: '',
      period_start: '',
      period_end: '',
      customerShow: false,
      rate_type: '',
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      options: [
        { text: 'Shipment', value: 'shipment' },
        { text: 'Firstmile', value: 'fm' },
        { text: 'Lastmile', value: 'lm' },
      ],
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
    rows() {
      return this.items.length;
    },
  },
  beforeCreate() {
    // this.$store
    //   .dispatch("OnBoardingScreenModule/getOnBoardingScreens")
    //   .then(response => {
    //     this.loading = false;
    //   })
    //   .catch(error => {
    //     this.$swal({
    //       type: "error",
    //       title: "Oops...",
    //       text: error.response.data.message,
    //       showConfirmButton: false,
    //       timer: 1500
    //     });
    //     this.loading = false;
    //   });
  },
  created() {
    // this.$store.watch(
    //   state => state.OnBoardingScreenModule.onboarding_screen,
    //   (newValue, oldValue) => {
    //     this.items = newValue;
    //   }
    // );
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  methods: {
    apply() {
      this.$refs.selectableTable.refresh();
    },
    reset() {
      this.period_start = '';
      this.period_end = '';
      this.rate_type = [];
      this.$refs.selectableTable.refresh();
    },
    resetStardate() {
      this.period_start = '';
    },
    resetEnddate() {
      this.period_end = '';
    },
    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append('search_param', ctx.filter);
      formData.append('limit', ctx.perPage);
      formData.append('page', ctx.currentPage);
      formData.append('sort_by', ctx.sortBy);
      formData.append('is_sort_asc', ctx.sortDesc);
      if (this.rate_type) {
        $.each(this.rate_type, (index, value) => {
          formData.append('rate_type', value);
        });
      } else {
        formData.append('rate_type', this.rate_type);
      }

      if (this.period_start != '' && this.period_end == '') {
        const start = this.period_start.toJSON().slice(0, 10);
        formData.append('period_start', start);
        formData.append('period_end', this.period_end);
      }
      if (this.period_end != '' && this.period_start == '') {
        const end = this.period_end.toJSON().slice(0, 10);
        formData.append('period_start', this.period_start);
        formData.append('period_end', end);
      }
      if (this.period_start != '' && this.period_end != '') {
        const start = this.period_start.toJSON().slice(0, 10);
        const end = this.period_end.toJSON().slice(0, 10);

        formData.append('period_start', start);
        formData.append('period_end', end);
      }
      if (this.period_start == '' && this.period_end == '') {
        formData.append('period_start', this.period_start);
        formData.append('period_end', this.period_end);
      }

      this.$store
        .dispatch('RatingModule/getRateReports', formData)
        .then((response) => {
          // let arr = response.data.data.map(data => {
          //   let article = JSON.parse(data.results);
          //   return {
          //     content: article.content.id,
          //     title: article.title.id,
          //     category: article.category
          //   };
          // });
          // vm.items = arr;
          vm.totalRows = response.data.data.total_record;
          callback(response.data.data.results || []);
          this.loading = false;
        })
        .catch((error) => {
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          // Returning an empty array, allows table to correctly handle
          // internal busy state in case of error
          this.isBusy = false;
          callback([]);
        });
      return null;
    },
    onRowSelected(items) {
      this.selected = items;
    },
    submitStatus(status) {
      const formData = new FormData();
      $.each(this.selected, (key, value) => {
        formData.append('onboarding_screen_id', value.id);
        formData.append('status', status);
      });
      $.each(formData.getAll('onboarding_screen_id'), (key, value) => {
        console.log(value);
      });

      this.loading = true;

      this.$store
        .dispatch('OnBoardingScreenModule/updateOnBoardingScreens', formData)
        .then((response) => {
          this.loading = false;
          this.$store.dispatch(
            'OnBoardingScreenModule/getOnBoardingScreens',
            null,
            {
              root: true,
            },
          );
          this.$swal({
            type: 'success',
            title: 'Your work has been saved',
            showConfirmButton: false,
            timer: 1000,
          });
          console.log(response);
        })
        .catch((error) => {
          this.loading = false;
          this.serverError = error.response;
          console.log(error);
        });
      // console.log(list);
    },
    toggleAll(checked) {
      this.selected = checked
        ? this.$refs.selectableTable.selectAllRows()
        : this.$refs.selectableTable.clearSelected();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    del(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(
            'OnBoardingScreenModule/delOnBoardingScreen',
            id,
          );
          this.$swal('Deleted!', 'Your file has been deleted.', 'success');
        }
      });
    },
  },
  watch: {
    selected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newVal.length === this.items.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
  },
};
</script>

<style>
</style>
